<template>
  <div class="checkbox-container"  @click="toggleSelected">
    <div class="checkbox-check" :class="borderColor">
      <div v-if="isCheck" class="check" :class="checkColor"></div>
    </div>
    <span class="name" :class="checkTextColor"> <small>{{ text }}</small></span>
  </div>
</template>

<script>
export default {
  name: "checkbox",
  props: {
    text: String,
    borderColor:{
        type:String,
        default: () => 'border-color-black'
    },
    checkColor:{
        type:String,
        default: () => 'bg-white'
    },
    checkTextColor:{
      type:String,
      default: () => 'text-white'
    }
  },
  data(){
      return{
        selected:false
      }
  },
  computed:{
    isCheck:{
      get: function(){
        return this.selected;
      },
      set: function(val){
        this.selected = val;
      }
    }
  },
  methods:{
    toggleSelected(){
      this.isCheck = !this.isCheck;
      this.$emit('checked',this.isCheck);
    }
  }
};
</script>

<style scoped lang="scss">
@import "./checkbox.scss";
</style>
